/**
 * Cái xe máy của quầy mang về.
 *
 * Vẽ bằng nét chứ không dán emoji 🛵: emoji mỗi hệ máy một kiểu và mang sẵn màu riêng, nên
 * đặt cạnh mấy hình vẽ khác là lạc hẳn ra. Nét thì ăn theo màu chữ của chỗ nó đứng.
 *
 * Một chỗ vẽ, ba chỗ dùng: dải điều hướng, màn hình Mang về, và tiêu đề của đơn mang về —
 * ba nơi này phải là cùng một cái xe thì người bán mới nối được chúng với nhau.
 */
export function ScooterGlyph({ className }: { className?: string }) {
  const stroke = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  }

  return (
    <svg
      viewBox="0 0 24 24"
      className={className ?? 'glyph'}
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="6.5" cy="17" r="2.6" {...stroke} />
      <circle cx="18" cy="17" r="2.6" {...stroke} />
      <path d="M9.1 17h6.3M4 8h3.4l2.6 5M13.5 6h3l2 6.5V17" {...stroke} />
    </svg>
  )
}
